import { useContext } from 'react'

import { EnvironmentContext } from '../context'

const useEnvironment = () => useContext(EnvironmentContext)

export default useEnvironment
